/**
 * This sets defaults and handles maintaining our auth token/params
 * between http requests.
 */

import Vue from 'vue';
import VueResource from 'vue-resource';
Vue.use(VueResource);


const course = Vue.resource('courses{/id}');


// example usage: #todo
// import subject from './resources/subject'
// subject.query({}).then((res) => {
//   console.log(res)
// }, (res) => {
//   console.log(res)
// })




export default course;



// WEBPACK FOOTER //
// ./src/resources/course.js